import { render } from "./edit-org-support-case.vue?vue&type=template&id=6b54876c"
import script from "./edit-org-support-case.vue?vue&type=script&lang=js"
export * from "./edit-org-support-case.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__